<div class="animated fadeIn mb-md-5 bg-sm-white">
    <mnf-dashboard-v2-summary-cards [user]="user" [profitUser]="profitUser" class="d-none d-lg-block"></mnf-dashboard-v2-summary-cards>
    <mnf-dashboard-v2-banner
        [userWithAutoGrowth]="userWithAutoGrowth" 
        [userWithDomiciliation]="userWithDomiciliation" 
        class="d-block d-lg-none">
    </mnf-dashboard-v2-banner>
    <div class="d-grid" [ngClass]="{'container': containerWidth}">
        <div class="row">
            <div class="col-xl-7 col-12 px-lg-0">
                <mnf-dashboard-v2-summary-cards [user]="user" [profitUser]="profitUser" class="d-block d-lg-none"></mnf-dashboard-v2-summary-cards>
                <mnf-dashboard-v2-banner 
                    [userWithAutoGrowth]="userWithAutoGrowth" 
                    [userWithDomiciliation]="userWithDomiciliation" 
                    class="banner-width d-none d-lg-block">
                </mnf-dashboard-v2-banner>
                <mnf-dashboard-v2-quick-actions [developmentsAvailable]="developmentsAvailable"></mnf-dashboard-v2-quick-actions>
                @if (!isNativePlatform) {
                    <mnf-dashboard-v2-project-list [developmentsAvailable]="developmentsAvailable" [userWithBothStatus]="userWithBothStatus"></mnf-dashboard-v2-project-list>
                }
            </div>
            <div class="col-xl-5 col-12">
                <div class="xl-container">
                    <mnf-dashboard-v2-submenu [profitUser]="profitUser"></mnf-dashboard-v2-submenu>
                    <mnf-dashboard-v2-slides class="w-auto d-grid" [status]="status"></mnf-dashboard-v2-slides>
                </div>
            </div>
        </div>
    </div>
</div>

